function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9062 11.0625H1.09375C0.489672 11.0625 0 11.4822 0 12C0 12.5178 0.489672 12.9375 1.09375 12.9375H26.9062C27.5103 12.9375 28 12.5178 28 12C28 11.4822 27.5103 11.0625 26.9062 11.0625Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9062 3.5625H1.09375C0.489672 3.5625 0 3.98222 0 4.5C0 5.01778 0.489672 5.4375 1.09375 5.4375H26.9062C27.5103 5.4375 28 5.01778 28 4.5C28 3.98222 27.5103 3.5625 26.9062 3.5625Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.9062 18.5625H1.09375C0.489672 18.5625 0 18.9822 0 19.5C0 20.0178 0.489672 20.4375 1.09375 20.4375H26.9062C27.5103 20.4375 28 20.0178 28 19.5C28 18.9822 27.5103 18.5625 26.9062 18.5625Z"
});

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.17b47d6f.svg";
export { ForwardRef as ReactComponent };